import * as React from 'react';
import { Link } from 'react-router-dom';

const SearchResultItem = 
({ id, name }: { id: string; name: string }) => {
    return (
        <div className="searchResultItem">
            <Link to={`/school/${id}`}><label>&nbsp;{name}</label></Link>
        </div>
    );
};

export default SearchResultItem;